"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GambleTransitionController = void 0;
/**
 * Created by jonas on 2020-05-26.
 */
const GameModeTransitionController_1 = require("./GameModeTransitionController");
const EventHandler_1 = require("../../../core/event/EventHandler");
const GameEvent_1 = require("../../../core/event/GameEvent");
const GameModeEvent_1 = require("../../../core/gamemode/event/GameModeEvent");
class GambleTransitionController extends GameModeTransitionController_1.GameModeTransitionController {
    constructor(fromMode, toMode) {
        super(fromMode, toMode);
    }
    prepareToEnterMode() {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(GameModeEvent_1.GameModeEvent.CHANGE_MODE, { newMode: this._serverData.nextMode }));
        EventHandler_1.EventHandler.dispatchEvent(new GameModeEvent_1.GameModeEvent(GameModeEvent_1.GameModeEvent.GAME_MODE_TRANSITION_PREPARE, this._fromMode, this._toMode));
    }
    cleanUpBeforeModeStart() {
        //nope, we dont want the super.cleanUpBeforeModeStart behaviour
    }
}
exports.GambleTransitionController = GambleTransitionController;
//# sourceMappingURL=GambleTransitionController.js.map